import moment from 'moment';
import {
  timeFormat,
  dateFormat,
  dateFormatCompare,
  timeFormatCompare,
} from 'utils/moment/moment.constant';

export function converTimeToString(time) {
  return time && moment(time).format(timeFormat);
}

export function converDateToString(date) {
  return date && moment(date).format(dateFormat);
}

/* Seconds To... */
export function secondsToTime(secs) {
  let days = Math.floor(secs / (60 * 60) / 24);
  let hours = Math.floor(secs / (60 * 60));

  let divisor_for_minutes = secs % (60 * 60);
  let minutes = Math.floor(divisor_for_minutes / 60);

  let divisor_for_seconds = divisor_for_minutes % 60;
  let seconds = Math.ceil(divisor_for_seconds);

  let obj = {
    d: days,
    h: hours,
    m: minutes,
    s: seconds,
  };
  return obj;
}
export function secondsToTimeLabel(secs) {
  const timeObj = secondsToTime(secs);

  let hour = timeObj?.h !== 0 ? timeObj?.h + 'h' : '';
  let min = timeObj?.m !== 0 ? timeObj?.m + '' : '';

  return hour ? `${hour}${min ? `${min}` : ''}` : min ? `${min} minutes` : '';
}
export function secondsToTimeLabelAbs(secs) {
  const timeObj = secondsToTime(secs);

  let hour = timeObj?.h !== 0 ? timeObj?.h + ' heures' : '';
  let min = timeObj?.m !== 0 ? timeObj?.m + '' : '';

  return hour
    ? `${hour}${min ? ` ${min} minutes` : ''}`
    : min
    ? `${min} minutes`
    : '';
}

/* Between Dates... */
export const isTimeBetween = function(aStartTime, anEndTime, aCurrTime) {
  // you may pass in aCurrTime or use the *actual* current time
  let currentTime = !aCurrTime ? moment() : moment(aCurrTime, 'HH:mm a');
  let startTime = moment(aStartTime, 'HH:mm a');
  let endTime = moment(anEndTime, 'HH:mm a');

  if (startTime.hour() >= 12 && endTime.hour() <= 12) {
    endTime.add(1, 'days'); // handle spanning days
  }

  let isBetween = currentTime.isBetween(startTime, endTime);

  return isBetween;
};
export const isDatesBetween = (aStartDate, anEndDate, aCurrDate) => {
  return (
    aStartDate &&
    anEndDate &&
    aCurrDate &&
    moment(aCurrDate, dateFormatCompare).isBetween(
      moment(aStartDate, dateFormatCompare),
      moment(anEndDate, dateFormatCompare),
    )
  );
};
export const getDaysBetweenDates = function(startDate, endDate) {
  let now = moment(startDate).clone(),
    dates = [];

  const momentEndDate = moment(endDate);

  while (now.isSameOrBefore(momentEndDate)) {
    dates.push(now.format(dateFormatCompare));
    now.add(1, 'days');
  }
  return dates;
};

/* Same Dates... */
export const isSameDates = (dateOne, dateTwo) => {
  return (
    dateOne &&
    dateTwo &&
    moment(dateOne, dateFormatCompare).isSame(
      moment(dateTwo, dateFormatCompare),
    )
  );
};

export const isSameTimes = (timeOne, timeTwo) => {
  return (
    timeOne &&
    timeTwo &&
    moment(timeOne, timeFormatCompare).isSame(
      moment(timeTwo, timeFormatCompare),
    )
  );
};

export function calculateBusinessDays(d1, d2) {
  const days = d2.diff(d1, 'days') + 1;
  let newDay = d1.toDate(),
    workingDays = 0,
    sundays = 0,
    saturdays = 0;

  for (let i = 0; i < days; i++) {
    const day = newDay.getDay();
    newDay = d1.add(1, 'days').toDate();
    const isWeekend = day % 6 === 0;
    if (!isWeekend) {
      workingDays++;
    } else {
      if (day === 6) saturdays++;
      if (day === 0) sundays++;
    }
  }

  return workingDays;
}

export const isDateBeforeToday = SpecialToDate => {
  if (!!SpecialToDate) {
    const now = moment().clone();
    const checkingDate = moment(
      SpecialToDate,
    );
    const diffValue = now
      .startOf('day')
      .diff(
        checkingDate.startOf('day'),
        'days',
      );
    return diffValue > 0;
  } else {
    return null;
  }
};

export const isDateAfterToday = SpecialToDate => {
  if (SpecialToDate) {
    const now = moment().clone();
    const checkingDate = moment(SpecialToDate);
    
    const diffValue = now
      .startOf('day')
      .diff(checkingDate.startOf('day'), 'days');
    
    return diffValue < 0;
  } else {
    return null;
  }
};

export const isDateBeforeDate = (dateOne, dateTwo) => {
  if (dateOne && dateTwo) {
    const now = moment(dateOne).clone();
    const checkingDate = moment(dateTwo);
    const diffValue = now
      .startOf('day')
      .diff(checkingDate.startOf('day'), 'days');
    return diffValue > 0;
  } else {
    return null;
  }
};

export const isDateBeforeDateBySeconds = (dateOne, dateTwo) => {
  if (dateOne && dateTwo) {
    const now = moment(dateOne).clone();
    const checkingDate = moment(dateTwo);
    const diffValue = now.diff(checkingDate, 'seconds');
    return diffValue > 0;
  } else {
    return null;
  }
};

export const isDateAfterDate = (dateOne, dateTwo) => {
  if (dateOne && dateTwo) {
    const now = moment(dateOne).clone();
    const checkingDate = moment(dateTwo);
    
    const diffValue = now
      .startOf('day')
      .diff(checkingDate.startOf('day'), 'days');
    return diffValue < 0;
  } else {
    return null;
  }
};


export const compareTimeRangeAndSetDefault = (timeOne, timeTwo) => {
  if (timeOne && timeTwo) {
    const timeOneMoment = moment(timeOne, timeFormatCompare);
    const timeTwoMoment = moment(timeTwo, timeFormatCompare);
  
    const isSame = timeTwoMoment.isSame(timeOneMoment, 'seconds');
    const isAfter = timeTwoMoment.isAfter(timeOneMoment, 'seconds');
    const isBefore = timeTwoMoment.isBefore(timeOneMoment, 'seconds');
    const diffTime = timeTwoMoment.diff(timeOneMoment, 'seconds');
    return {
      isSame: isSame,
      isAfter: isAfter,
      isBefore: isBefore,
      diff: diffTime > 0 ? diffTime/60 : 0,
    };
  } else {
    return null;
  }
};

export const compareDateRangeAndSetDefault = (dateOne, dateTwo) => {
  if (dateOne && dateTwo) {
    const dateOneMoment = moment(dateOne, dateFormatCompare);
    const dateTwoMoment = moment(dateTwo, dateFormatCompare);

    const isSame = isSameDates(dateOne, dateTwo);
    const isAfter = isDateAfterDate(dateOne, dateTwo);
    const isBefore = isDateBeforeDate(dateOne, dateTwo);
    const diffDays = dateTwoMoment
      .startOf('day')
      .diff(dateOneMoment.startOf('day'), 'days');
    return {
      isSame: isSame,
      isAfter: isAfter,
      isBefore: isBefore,
      diff: diffDays > 0 ? diffDays : 0,
    };
  } else {
    return null;
  }
};


export const convertTimeForChat = (timestamp) => {
  const now = moment();
  const messageTime = moment(timestamp);
  const diff = now.diff(messageTime, 'minutes');
  const isToday = now.isSame(messageTime, 'day');

  if (diff < 50) {
    return messageTime.locale('fr').fromNow();
  } else if (isToday) {
    return messageTime.format('HH:mm');
  } else {
    return messageTime.format('Do MMMM YYYY — HH:mm');
  }
};
